import { Link } from "@tanstack/react-router"
import { IconPlusOutline18 as Plus } from "nucleo-ui-outline-18"

const ROW_CLASS =
	"flex h-[1.9rem] w-full min-w-0 cursor-default items-center gap-2 rounded-md pl-2 pr-1 text-left text-[13px] font-medium text-tertiary hover:bg-gray-100 hover:text-secondary focus-visible:bg-gray-100 focus-visible:outline-none hover:dark:bg-gray-800/50 dark:focus-visible:bg-gray-800/50"

// The row a section shows instead of collapsing to a bare label, so an empty
// Public, Agent, Internal and Sources each still say what belongs in them.
export const DocsNavPlaceholderRow = ({
	label,
	onClick,
	to,
}: {
	label: string
	onClick?: () => void
	to?: string
}) => {
	const body = (
		<>
			<span className="flex size-3.5 flex-none items-center justify-center rounded border border-dashed border-gray-300 dark:border-gray-600">
				<Plus className="size-2.5 flex-none" />
			</span>
			<span className="min-w-0 flex-1 truncate">{label}</span>
		</>
	)

	if (to) {
		return (
			<Link to={to} className={ROW_CLASS}>
				{body}
			</Link>
		)
	}

	return (
		<button type="button" onClick={onClick} className={ROW_CLASS}>
			{body}
		</button>
	)
}
